export default __webpack_public_path__ + "static/media/gallery_02.8c0deab4.jpg";